import { TimeDropdownProperties } from '../../../types';
import useFormControls from './useFormControls';
import { FieldInputProps, FormikProps } from 'formik';
import { Maybe } from '../../../../../types';
import React from 'react';
import { FormikOutreachSupportTimeValue } from '../controls/OutreachConfig/support/FormikOutreachSupportTimeField';
import DateTimeFieldRenderer from '../controls/OutreachConfig/DateTimeFieldRenderer';

export type UseTimeFieldActionsValues = {
  renderDropdownFor: (property: TimeDropdownProperties) => JSX.Element;
};

const NEVER_ENDS = 'never-ends';

const useTimeFieldActions = (
  field: FieldInputProps<FormikOutreachSupportTimeValue>,
  form: FormikProps<FormikOutreachSupportTimeValue>,
): UseTimeFieldActionsValues => {
  const { setPropertyValue } = useFormControls<FormikOutreachSupportTimeValue>(
    field,
    form,
  );

  const handleDropdownSelection = (
    property: TimeDropdownProperties,
    value: Maybe<string>,
  ) => {
    if (value === NEVER_ENDS) {
      setPropertyValue(property, undefined);
      return;
    }
    setPropertyValue(property, value ? new Date(value) : undefined);
  };

  const renderDropdownFor = (property: TimeDropdownProperties) => {
    return (
      <DateTimeFieldRenderer
        field={field}
        form={form}
        property={property}
        handleDropdownSelection={handleDropdownSelection}
      />
    );
  };

  return { renderDropdownFor };
};

export default useTimeFieldActions;
